import { HttpStatusCode } from 'axios';

const axiosErrorToTranslationKey = (error: any): string => {
  if (error.response) {
    switch (error.response.status) {
      case 400:
        return 'invalidRequestBody';
      case 401:
        return 'unauthorized';
      case 403:
        return 'forbidden';
      case 404:
        return 'notFound';
      case 405:
        return 'notAllowed';
      case 500:
        return 'internalServerError';
      default:
        return 'unexpectedError';
    }
  }
  return 'unexpectedError';
};

export const cm360ErrorCodes = {
  [HttpStatusCode.Forbidden]: {
    cm01: {
      code: 'cm01',
      translationKey: 'NOTIFICATION.ERROR.bookingAlreadyDone',
    },
    cm02: {
      code: 'cm02',
      translationKey: 'NOTIFICATION.ERROR.emailIsIncorrect',
    },
  },
  [HttpStatusCode.Conflict]: {
    cm409_01: {
      code: 'cm409_01',
    },
  },
};

export default axiosErrorToTranslationKey;
